// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"j3-z","dimensionLabel":"k3-z","styleChooserControlWrapper":"l3-z","styleChooserControl":"m3-z","disabled":"n3-z","giftCard":"o3-z","styleChooserText":"p3-z"};